import { useState } from "react";
import PhotoUpload from "../../../components/PhotoUpload";
import SelectField from "../../../components/SelectField";

const CONDITION_OPTIONS = [
  { value: "buna", label: "Buna" },
  { value: "satisfacatoare", label: "Satisfacatoare" },
  { value: "uzura_normala", label: "Uzura normala" },
];


export default function PVRoomsStep({ data, setField }) {
  const rooms = data.pvRooms || [];
  const [activeTab, setActiveTab] = useState(0);

  if (rooms.length === 0) {
    return (
      <p style={{ fontSize: "14px", color: "#8a7e70", fontFamily: "'DM Sans', sans-serif" }}>
        Nu ai selectat nicio camera. Mergi inapoi la pasul anterior si selecteaza camerele.
      </p>
    );
  }

  const room = rooms[activeTab] || rooms[0];

  const updateRoom = (roomIndex, field, value) => {
    const updated = rooms.map((r, i) => (i === roomIndex ? { ...r, [field]: value } : r));
    setField("pvRooms", updated);
  };

  const addItem = () => {
    const items = [...(room.items || []), { name: "", condition: "buna" }];
    updateRoom(activeTab, "items", items);
  };

  const updateItem = (itemIndex, field, value) => {
    const items = (room.items || []).map((item, i) =>
      i === itemIndex ? { ...item, [field]: value } : item
    );
    updateRoom(activeTab, "items", items);
  };

  const removeItem = (itemIndex) => {
    const items = (room.items || []).filter((_, i) => i !== itemIndex);
    updateRoom(activeTab, "items", items);
  };

  return (
    <div>
      {/* Tabs */}
      <div style={{ display: "flex", gap: "4px", marginBottom: "20px", flexWrap: "wrap" }}>
        {rooms.map((r, i) => (
          <button
            key={r.id}
            onClick={() => setActiveTab(i)}
            style={{
              padding: "8px 16px",
              borderRadius: "8px",
              border: `2px solid ${i === activeTab ? "#c45d3e" : "#e8e0d4"}`,
              backgroundColor: i === activeTab ? "rgba(196, 93, 62, 0.08)" : "#fdfbf7",
              color: i === activeTab ? "#c45d3e" : "#4a3f35",
              fontWeight: i === activeTab ? 700 : 500,
              fontSize: "13px",
              fontFamily: "'DM Sans', sans-serif",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
          >
            {r.label}
            {(r.items || []).length > 0 && ` (${r.items.length})`}
          </button>
        ))}
      </div>

      {/* Room content */}
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {/* Room state */}
        <div>
          <SelectField
            label={`Stare camera — ${room.label}`}
            value={room.stare || "default"}
            onChange={(e) => updateRoom(activeTab, "stare", e.target.value)}
            options={[
              { value: "default", label: `Ca starea generala (${data.pvStareGenerala || "buna"})` },
              ...[
                { value: "buna", label: "Buna" },
                { value: "satisfacatoare", label: "Satisfacatoare" },
                { value: "necesita reparatii", label: "Necesita reparatii" },
              ].filter(opt => opt.value !== (data.pvStareGenerala || "buna")),
            ]}
            half
          />
          <p style={{ fontSize: "11px", color: "#8a7e70", margin: "4px 0 0 0", fontStyle: "italic" }}>
            Starea este constatata vizual la data predarii.
          </p>
          {(room.stare === "satisfacatoare" || room.stare === "necesita reparatii") && (
            <p style={{ fontSize: "11px", color: "#c45d3e", margin: "4px 0 0 0", fontStyle: "italic" }}>
              Recomandat: completati observatii.
            </p>
          )}
        </div>

        {/* Items table */}
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
            <label style={{
              fontSize: "13px", fontWeight: 600, color: "#4a3f35",
              fontFamily: "'DM Sans', sans-serif", letterSpacing: "0.02em",
            }}>
              Inventar obiecte — {room.label}
            </label>
            <button
              onClick={addItem}
              style={{
                padding: "6px 16px",
                borderRadius: "8px",
                border: "none",
                background: "linear-gradient(135deg, #c45d3e 0%, #a84832 100%)",
                color: "#fff",
                fontSize: "12px",
                fontWeight: 600,
                fontFamily: "'DM Sans', sans-serif",
                cursor: "pointer",
              }}
            >
              + Adauga obiect
            </button>
          </div>

          {(room.items || []).length === 0 ? (
            <p style={{
              fontSize: "13px", color: "#b8a890", fontStyle: "italic",
              fontFamily: "'DM Sans', sans-serif", padding: "16px",
              backgroundColor: "#fdfbf7", borderRadius: "8px",
              border: "2px dashed #e8e0d4", textAlign: "center",
            }}>
              Niciun obiect adaugat. Apasa "+ Adauga obiect" pentru a incepe.
            </p>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {(room.items || []).map((item, idx) => (
                <div key={idx} style={{
                  display: "flex", gap: "8px", alignItems: "center",
                  padding: "8px 12px", backgroundColor: "#fdfbf7",
                  borderRadius: "8px", border: "1px solid #e8e0d4",
                }}>
                  <div style={{ flex: 2 }}>
                    <input
                      value={item.name}
                      onChange={(e) => updateItem(idx, "name", e.target.value)}
                      placeholder="Nume obiect (ex: Canapea, TV, Frigider)"
                      style={{
                        width: "100%", padding: "8px 12px",
                        border: "2px solid #e8e0d4", borderRadius: "8px",
                        fontSize: "14px", fontFamily: "'DM Sans', sans-serif",
                        backgroundColor: "#fff", color: "#2d2418",
                        outline: "none", boxSizing: "border-box",
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <select
                      value={item.condition}
                      onChange={(e) => updateItem(idx, "condition", e.target.value)}
                      style={{
                        width: "100%", padding: "8px 12px",
                        border: "2px solid #e8e0d4", borderRadius: "8px",
                        fontSize: "14px", fontFamily: "'DM Sans', sans-serif",
                        backgroundColor: "#fff", color: "#2d2418",
                        outline: "none", cursor: "pointer", boxSizing: "border-box",
                      }}
                    >
                      {CONDITION_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>
                  <button
                    onClick={() => removeItem(idx)}
                    style={{
                      width: "32px", height: "32px", borderRadius: "8px",
                      border: "none", backgroundColor: "rgba(229, 62, 62, 0.1)",
                      color: "#e53e3e", fontSize: "16px", cursor: "pointer",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    x
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Photos */}
        <div>
          <label style={{
            display: "block", fontSize: "13px", fontWeight: 600, color: "#4a3f35",
            marginBottom: "8px", fontFamily: "'DM Sans', sans-serif", letterSpacing: "0.02em",
          }}>
            Fotografii — {room.label} (max 3)
          </label>
          <PhotoUpload
            photos={room.photos || []}
            onChange={(photos) => updateRoom(activeTab, "photos", photos)}
            max={3}
          />
        </div>

        {/* Observations */}
        <div>
          <label style={{
            display: "block", fontSize: "13px", fontWeight: 600, color: "#4a3f35",
            marginBottom: "6px", fontFamily: "'DM Sans', sans-serif", letterSpacing: "0.02em",
          }}>
            Observatii — {room.label}
          </label>
          <textarea
            value={room.observations || ""}
            onChange={(e) => updateRoom(activeTab, "observations", e.target.value)}
            placeholder="ex: parchet zgariat langa fereastra, tencuiala crapata pe peretele nordic"
            rows={3}
            style={{
              width: "100%", padding: "12px 16px",
              border: "2px solid #e8e0d4", borderRadius: "10px",
              fontSize: "15px", fontFamily: "'DM Sans', sans-serif",
              backgroundColor: "#fdfbf7", color: "#2d2418",
              outline: "none", boxSizing: "border-box",
              resize: "vertical",
            }}
          />
        </div>
      </div>
    </div>
  );
}
